// extracted by mini-css-extract-plugin
export default {"botaoSalvar":"styles_botaoSalvar__yjg8D"};